import { any, func } from "prop-types";
import React from "react";
import { connect } from "react-redux";
import moment from "moment";
import {
  formCreatorConvertToValues,
  useForm,
} from "../../common/FormCreator/helpers";
import FormCreator from "../../common/FormCreator";
import history from "../../history";
import { postDrivingForm } from "../../redux/actions";
import HorizontalLine from "../../common/HorizontalLine";

const ComplianceAndDriversDeclaration = ({ appData, postDrivingFormFunc }) => {
  const initialData = {
    date: moment().format("DD/MM/YYYY"),
    signed: `${appData.firstName} ${appData.lastName}`,
    ...(appData.drivingOnboarding &&
      appData.drivingOnboarding.complianceAndDriversDeclaration),
  };
  const isEmpty = (val) => typeof val === "undefined" || val === null;
  const getField = (data) => (fieldName) =>
    !isEmpty(data[fieldName]) ? data[fieldName] : "";

  const getVal = getField(initialData);

  const initialState = {
    entitlementAndCompliance: {
      htmlObj: (
        <div className="text-justify">
          <HorizontalLine text="Entitlement to drive" />
          <p>
            <b>
              It is an offence for a person to drive on a road any vehicle
              otherwise than in accordance with a licence authorising them to
              drive it. It is also an offence for a person to cause or permit
              another person to drive it.
            </b>
          </p>
          <p>
            You are required to produce your latest licence to HRGO Recruitment
            and their clients when requested. You must also inform HRGO
            Recruitment of any road traffic incidents, convictions, endorsements
            or disqualifications that have occurred or occur, which could affect
            your entitlement to drive, as soon as possible.
          </p>
          <p>
            <b>
              Changes in your health can also affect your entitlement to drive,
              in particular, for ALL licences:
            </b>
          </p>
          <ul>
            <li>Epilepsy</li>
            <li>Fits or blackouts</li>
            <li>
              Repeated attacks of sudden disabling giddiness (dizziness that
              prevents you from functioning normally)
            </li>
            <li>Diabetes controlled by insulin</li>
            <li>An implanted cardiac pacemaker</li>
            <li>An implanted cardiac defibrillator (ICD)</li>
            <li>Persistent alcohol abuse or dependency</li>
            <li>Persistent drug abuse or dependency</li>
            <li>Parkinson’s disease</li>
            <li>Narcolepsy or sleep apnoea syndrome</li>
            <li>
              Stroke, with any symptoms lasting longer than one month, recurrent
              ‘mini strokes’ or TlAs (Transiant lschaemic Attacks)
            </li>
            <li>
              Any type of brain surgery, severe head injury involving inpatient
              treatment, or brain tumour
            </li>
            <li>Any other chronic (long term) neurological condition</li>
            <li>A serious problem with memory or episodes of confusion</li>
            <li>Severe learning disability</li>
            <li>Serious psychiatric illness or mental ill-health</li>
            <li>Total loss of sight in one eye</li>
            <li>
              Any condition affecting both eyes, or the remaining eye only (not
              including short or long sight or colour blindness)
            </li>
            <li>
              Any condition affecting your visual field (the surrounding area
              you can see when looking directly ahead)
            </li>
            <li>
              Any persistent limb problem for which your driving has to be
              restricted to certain types of vehicles or those with adapted
              controls
            </li>
          </ul>
          <p>
            <b>Also, for vocational licences you must declare:</b>
          </p>
          <ul>
            <li>Angina, other heart conditions or heart operation</li>
            <li>Diabetes controlled by tablets</li>
            <li>Visual problems affecting either eye</li>
            <li>
              Any form of stroke, including TIAs (Transiant Ischaemic Attacks)
            </li>
          </ul>
          <p>
            If any of the above affects you, you must inform HRGO Recruitment as
            soon as possible. You must also inform DVLA by writing to the:
            Drivers Medical Group, DVLA, Swansea SA99 1TU (the appropriate
            medical questionnaires can be downloaded from
            www.direct.gov.uk/driverhealth). Failure to do so is a criminal
            offence punishable by a fine of up to £1,000.
          </p>

          <HorizontalLine text="Compliance" />
          <p>
            <b>
              You are required to understand and comply with all relevant
              legislation in relation to road transport and any other reasonable
              requests during your placement with our clients. In particular,
              you must:
            </b>
          </p>
          <ul>
            <li>
              understand and will comply with the rules on EU drivers’ hours and
              records requirement, domestic drivers’ hours rules and records,
              and working time limits for mobile workers in the road transport
              sector, as appropriate
            </li>
            <li>
              have taken sufficient daily and weekly rest prior to the placement
            </li>
            <li>
              have sufficient duty and driving time available to be able to work
              the shift(s) allocated to you
            </li>
            <li>
              have (and will continue to have) on your person the drivers’ hours
              records required to be produced to an enforcement officer if
              requested, namely:
              <ul>
                <li>digital driver’s card (if you hold one)</li>
                <li>
                  analogue tachograph charts for the current day & the previous
                  28 calendar days (if you drove a vehicle fitted with analogue
                  equipment in that time)
                </li>
                <li>
                  any written manual records and printouts legally required for
                  the current day and the previous 28 calendar days
                </li>
              </ul>
            </li>
            <li>
              ensure the original analogue charts and any legally required
              printouts or written manual records, which relate to your
              placement, are returned to the client or HRGO Recruitment within
              42 days
            </li>
            <li>
              ensure your digital driver’s card is downloaded at the required
              intervals and in any case at the end of your placement, before you
              leave the site
            </li>
            <li>
              have a full valid licence (with no disqualifications) for the type
              of vehicle you are being asked to drive
            </li>
            <li>
              where appropriate, hold a Driver CPC and carry your Driver CPC
              qualification card
            </li>
            <li>
              inform the client and HRGO Recruitment of any encounters with DVSA
              (formally known as VOSA), the police or other enforcement officers
            </li>
            <li>never use a hand-held mobile phone whilst driving</li>
            <li>
              report any accidents or near misses that you are involved in to
              the client and HRGO Recruitment
            </li>
            <li>
              carry out daily walk around vehicle checks using the documents
              provided and report any defects
            </li>
            <li>
              understand and comply with speed limits of roads and vehicles
            </li>
            <li>
              not drive a vehicle whilst under the influence of drink or drugs
              (whether illegal or prescribed)
            </li>
            <li>
              ensure that the load on your vehicle is secure and within the
              limits of the vehicle in terms of weight and distribution
            </li>
            <li>
              comply with any health and safety requirements on this site and
              any site visited during your placement
            </li>
            <li>
              return the vehicle and its equipment in the same condition that
              you received it in
            </li>
          </ul>
          <p>
            You must be satisfied that you are legally able to undertake the
            duties required of you and must advise the client or HRGO
            Recruitment if you have any doubts, concerns or problems with any
            issue in relation to performing your duties during your placement.
          </p>
          <HorizontalLine text="Drivers declaration" />
        </div>
      ),
    },
    motoringOffence: {
      title:
        "Have you been convicted of any motoring offence in the last 5 years? (other than parking)",
      value: getVal("motoringOffence"),
      type: "radio",
      radioOptions: ["Yes", "No"],
      mandatory: true,
    },
    motoringOffenceDetails: {
      title: "Please give details",
      value: getVal("motoringOffenceDetails"),
      dependOn: [
        {
          fieldKey: "motoringOffence",
          allowedValues: ["Yes"],
        },
      ],
      mandatory: true,
    },
    revokedOrSuspendedLicence: {
      title:
        "Have you had your licence revoked or suspended in the last 10 years?",
      value: getVal("revokedOrSuspendedLicence"),
      type: "radio",
      radioOptions: ["Yes", "No"],
      mandatory: true,
    },
    revokedOrSuspendedLicenceDetails: {
      title: "Please give details",
      value: getVal("revokedOrSuspendedLicenceDetails"),
      dependOn: [
        {
          fieldKey: "revokedOrSuspendedLicence",
          allowedValues: ["Yes"],
        },
      ],
      mandatory: true,
    },
    prosecution: {
      title:
        "At the time of signing this form, are you aware of any pending prosecution or circumstances that might result in future prosecution?",
      value: getVal("prosecution"),
      type: "radio",
      radioOptions: ["Yes", "No"],
      mandatory: true,
    },
    prosecutionDetails: {
      title: "Please give details",
      value: getVal("prosecutionDetails"),
      dependOn: [
        {
          fieldKey: "prosecution",
          allowedValues: ["Yes"],
        },
      ],
      mandatory: true,
    },
    spacer: {
      htmlObj: <div style={{ paddingTop: "1px" }} />,
    },
    passTelephone: {
      title: `I consent that in the event that I am on assignment with a HRGO Recruitment client who requires to contact me urgently, HRGO Recruitment can pass over my telephone number.`,
      value: getVal("passTelephone"),
      type: "singlecheckbox",
    },
    entitlementToDrive: {
      htmlObj: (
        <div className="text-justify">
          <p>
            <b>
              HRGO Recruitment do not expect you to answer your mobile phone
              whilst driving whether you are using a hands free device or not.
            </b>
          </p>
          <p>
            I undertake to inform HRGO Recruitment of anything occurring in the
            future which may result in prosecution or the impairment of my
            driving ability.
          </p>
          <p>
            I acknowledge that it is my responsibility to ensure that any
            Tachograph issued to me by the client is completed correctly and
            returned to the client unless alternative arrangements have been
            notified to me. I further acknowledge that should a Digital
            Tachograph be in use in any client vehicle, use of my Drivers card
            in accordance with EC regulation No. 561/2206 is my responsibility.
          </p>
          <p>
            I hereby confirm that before taking over any vehicle, it is my
            responsibility to carry out all duties laid on the driver under the
            Motor Vehicles (Construction and Use) Regulations and Road Vehicles
            Lighting Requirements, The Transports Acts and any other applicable
            regulations, and in addition shall be responsible for all daily
            and/or weekly checks to ensure the vehicle is roadworthy at all
            times.
          </p>

          <p>
            <b>Working time (Road Transport) Regulations 2005</b>
          </p>
          <p>
            I confirm that I am aware of my obligations under the Regulations to
            accurately record by periods of availability, working time and
            periods of might work as defined by the Regulations and not to
            exceed the maximum hours permitted.
          </p>
          <p>
            I undertake to inform the Company of the number of hours worked by
            me either through the Company on my own account or for any other
            firm, company or agency during any relevant reference period and to
            indemnify the Company against any losses, damages, fines or expenses
            that it suffers as a result of me knowingly or carelessly providing
            false information.
          </p>
          <p>
            For the purposes of calculating the 48 hours per week average for
            the reference period I agree to the 26 week reference period as
            outlined in the horizontal directive for the Working Time
            Regulations for Transport.
          </p>
          <p>
            I understand that failure could lead to a fine of up to £5,000 or
            criminal prosecution under the Regulations.
          </p>

          <p>
            <b>Night working</b>
          </p>
          <p>
            I understand that I have the option under the Regulations to agree
            to additional flexibility in night working and changing the
            reference periods over which my working time is calculated.
          </p>
          <p>
            I wish to extend night working limits and will work beyond 10 hour
            night work limit set out in the Regulations but only to the extent
            that this would not breach any other provisions of the Regulations
            or the EU Drivers Hours Regulations 3820/85.
          </p>

          <p>
            <b>
              By signing below I agree to abide by all current UK/EU law and to
              all HRGO policies and procedures.
            </b>
          </p>
        </div>
      ),
    },
    signed: {
      title: "Signed",
      value: getVal("signed"),
      mandatory: true,
    },
    date: {
      title: "Date",
      value: getVal("date"),
      mandatory: true,
    },
  };

  const [fields, setField] = useForm(initialState);
  const handleSubmit = () => {
    postDrivingFormFunc(
      "complianceAndDriversDeclaration",
      formCreatorConvertToValues(fields)
    );
    history.push("/profile/edit/driving-onboarding");
  };
  return (
    <FormCreator
      formTitle={"Compliance & Drivers Declaration"}
      fields={fields}
      setField={setField}
      onboardingBranch="driving"
      handleSubmit={handleSubmit}
      handleCancel={() => history.push("/profile/edit/driving-onboarding")}
    />
  );
};

ComplianceAndDriversDeclaration.propTypes = {
  appData: any,
  postDrivingFormFunc: func.isRequired,
};
const mapDispatchToProps = {
  postDrivingFormFunc: postDrivingForm,
};
const mapStateToProps = (state) => ({
  appData: state.core.app,
});
const withRedux = connect(mapStateToProps, mapDispatchToProps);
export default withRedux(ComplianceAndDriversDeclaration);
